<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <LoginForm />
        Sign in page
      </div>
    </div>
  </div>
</template>

<script>
    import { LoginForm } from "@/components";

    export default {
        components: {
            LoginForm,
        }
    };
</script>